   // Accordian Action

   var action = 'click';

   var speed = "800";

   

   

   $(document).ready(function(){

   

   // Question handler

     var $allFaqs = $('li.faq-question').on(action, function(){

   

       /* // gets next element */

       /* // opens .a of selected question */

       $(this).next().slideToggle(speed)

       

       

       /* // selects all other answers and slides up any open answer */

       .siblings('li.faq-answer').slideUp();

         $(this).toggleClass('faq-active');

       /* // Grab img from clicked question */

       var svg = $(this).children('svg');

   

       /* // remove Rotate class from all images except the active */

       $('svg').not(svg).removeClass('rotate');

       

       $(".ind-faq").removeClass("faq-ind-active");

   

       if(svg.hasClass("rotate")){

           $(this).closest(".ind-faq").toggleClass('faq-ind-active');

             svg.removeClass('rotate');

       }else{

           svg.addClass('rotate');

       }

       $(this).closest(".ind-faq").toggleClass('faq-ind-active');

   

       /* // collapse all the other accordions that are open */

       toggleFaqs($allFaqs.not(this).filter('.faq-active'));

     

     });

     

     

   

   });

   

   function toggleFaqs ($faqs) {

       $faqs.toggleClass('faq-active'); // This is for icon

       $faqs.next().slideToggle();

   }